import { useQuery } from "@tanstack/react-query";
import {
  getStoreManualDayEntry,
  type StoreManualDayEntry,
} from "services/auditService";

export function useAuditDashboardManualDayEntry(
  storeId: string | null | undefined,
  businessDate: string | null | undefined,
  enabled = true
) {
  return useQuery<StoreManualDayEntry | null, Error>({
    queryKey: ["store-manual-day-entry", storeId, businessDate],
    queryFn: () => getStoreManualDayEntry(storeId!, businessDate!),
    enabled: Boolean(enabled && storeId && businessDate),
  });
}
